"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockPromoBanner = void 0;
function mockPromoBanner(overrides = {}) {
    return {
        content: 'mock banner',
        id: 1,
        order: 1,
        tooltip: null,
        ...overrides,
    };
}
exports.mockPromoBanner = mockPromoBanner;
